<template>
  <component
    :is="tag"
    :class="classList"
    :target="isLink ? '_blank' : undefined"
    class="c-item a-static relative flex items-center ltr:pl-2 rtl:pr-2 py-1 w-full hover:bg-basic-hover after:scale-x-0"
    @click="onClick"
  >
    <c-icon
      v-if="icon"
      :background="backgroundIcon"
      :color="color"
      :icon="icon"
      :size="size"
    />
    <div class="c-item__body grow">
      <div class="c-item__text ltr:pr-2 rtl:pl-2 font-subtitle2" v-html="propText"/>
      <div v-if="description" class="c-item__description font-body2">{{ description }}</div>
    </div>
    <div
      v-if="badge"
      class="c-item__badge flex justify-center items-center px-3 h-5 font-caption bg-basic-hover"
      v-html="badge"
    />
    <c-icon v-if="iconTrailing" :icon="iconTrailing" :turn="turn" class="ltr:mr-1 rtl:ml-1"/>
  </component>
</template>

<script>
import CIcon from '@/components/CIcon'
import { props } from './props'
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import getExp from 'dcode/functions/getExp'

export default {
  name: 'CItem',
  components: { CIcon },
  props,
  emits: ['on-click'],
  setup (props, context) {
    const router = useRouter()
    const propText = computed(() => props.underline
      ? props.text.toString().replace(
        getExp(props.underline, '(:value)'),
        subtext => `<span class="c-item__underline">${subtext}</span>`
      )
      : props.text)

    const isLink = computed(() => props.to && props.to.match(/^http[s]:\/\//ig))
    const tag = computed(() => {
      if (!props.to && !props.href) {
        return 'div'
      }
      return props.tag || 'a'
    })

    const backgroundIcon = computed(() => {
      return [
        'medium',
        'large'
      ].indexOf(props.size) !== -1
    })

    const classList = computed(() => {
      return {
        'status-focus': props.focus,
        'status-selected': props.selected,
        'status-hover-none': props.hoverNone,
        [`size-${props.size}`]: props.size,
        'option-border': props.border
      }
    })

    const onClick = event => {
      if (props.to && !isLink.value) {
        event.preventDefault()
        router.push(props.to)
      }

      context.emit('on-click', {
        item: props.item,
        value: props.value
      })
    }

    return {
      propText,
      isLink,
      tag,
      backgroundIcon,
      classList,
      onClick
    }
  }
}
</script>

<style lang="scss">
@import "style";
</style>
